module.exports = __webpack_public_path__ + "static/integration-d52b1ccc0508f4d70e9cf49db9f52978.svg";